/**
 * @author: yuanchang@baidu.com
 * @datetime: 2017-05-16 20:23:32
 * @file: Description
 */

import Vue from "vue";
import App from "./App";
import Vuex from "vuex";
import axios from "./http";
import request from "./http/request";
//import iView from "iview";
import iView from "view-design";
import locale from 'view-design/dist/locale/en-US';



//import "iview/dist/styles/iview.css";
import "view-design/dist/styles/iview.css";

import "!style-loader!css-loader!less-loader!./components/my-theme/index.less";
import VueECharts from "vue-echarts";

import HTTP from "./http";
import URL from "./http/url";
import walden from "./lib/walden";
import util from "./lib/util";
Vue.prototype.$request = request;
Vue.prototype.$api_url = URL;
Vue.prototype.$util = util;
Vue.use(Vuex);
Vue.use(iView,{ locale });
Vue.component("chart", VueECharts);
VueECharts.registerTheme("walden", walden);

import router from "./router";

// 记录全局store，后续多了可独立
const store = new Vuex.Store({
  state: {
    root: "",
    menu: "",
    submenu: "",
    // username: '',
    username: location.hostname === "duadmin.baidu.com" ? "" : "test",
    uuap: "https://uuap.baidu.com"
  },
  mutations: {
    // 更新目录active状态
    updatemenu(state, name) {
      const menuList = name.split("-");
      if (menuList.length > 1) {
        state.root = menuList[0];
        state.menu = `${menuList[0]}-${menuList[1]}`;
        state.submenu = name;
      } else {
        state.root = menuList[0];
        state.menu = "";
        state.submenu = "";
      }
    },
    username(state, name) {
      state.username = name;
    }
  }
});

// 注册数据探索vuex
store.registerModule("exploration", {
  state: {
    url: "",
    formdata: {},
    tableColumns: [],
    tableData: [],
    division: [],
    statistics: []
  },
  mutations: {
    // 更新查询数据
    updateFormdata(state, value) {
      state.formdata = value;
    },
    // 更新查询数据
    updateURL(state, value) {
      state.url = value;
    },
    updateTableColumns(state, value) {
      state.tableColumns = value;
    },
    updateTableData(state, value) {
      state.tableData = value;
    },
    updateDivision(state, value) {
      state.division = value;
    },
    updateStatistics(state, value) {
      state.statistics = value;
    }
  }
});

// 注册数据探索vuex
store.registerModule("condition", {
  state: {
    adv_id: [],
    offer_id: "",
    aff_id: [],
    aff_nickname: "",
    aff_sub_id: "",
    merge_aff_sub_id: "",
    offer_country: [],
    app_id: "",
    aff_app_id: "",
    adv_offer_id: "",
    start_hour: "",
    end_hour: "",
    revenue_max: -1,
    revenue_min: -1,
    click_max: -1,
    click_min: -1,
    profit_max: -1,
    profit_min: -1,
    start_date: util.formatDate(new Date(), "yyyy-mm-dd"),
    end_date: util.formatDate(new Date(), "yyyy-mm-dd"),
    platform: "",
    time_zone: "8",
    ext_type: "",
    adv_type: ""
  },
  mutations: {
    updateCondition(state, formdata) {
      for (const i in formdata) {
        // 防止指标和维度写入vuex
        if (state.hasOwnProperty(i)) {
          if (i === "adv_id" || i === "aff_id" || i === "offer_country") {
            state[i] =
              typeof formdata[i] === "string"
                ? [formdata[i]]
                : formdata[i].concat();
          } else {
            state[i] = formdata[i];
          }
        }
      }
    }
  }
});

// 页面跳转前钩子
router.beforeEach((to, from, next) => {
  if (!store.state.username) {
    const ticket = to.query.ticket;
    const service = location.origin + location.pathname;
    const search = location.search;
    const appKey = "uuapclient-13-MISIzENMwXrjbXfzmSo5";

    // 验证为下游系统生成的ticket
    // http://wiki.baidu.com/pages/viewpage.action?pageId=152116848
    if (ticket) {
      HTTP.request({
        url: URL.login,
        method: "post",
        data: {
          service,
          ticket,
          appKey
        }
      }).then(res => {
        if (res.errno === 0) {
          store.commit("username", res.data.user_name);
          store.commit("updatemenu", to.name);
          // delete(to.query.ticket);
          // console.log(to.query);
          // next({path: to.path, query: to.query});
          next(to.path + window.sessionStorage.getItem("anti"));
        } else {
          store.commit("username", "notFound");
        }
      });
    } else {
      window.sessionStorage.setItem("anti", search);
      window.location = `${store.state.uuap}/login?service=${service}&appKey=uuapclient-13-MISIzENMwXrjbXfzmSo5`;
    }
  } else {
    store.commit("updatemenu", to.name);
    next();
  }
});

// 页面跳转完钩子
router.afterEach((to, from, next) => {
  window.scrollTo(0, 0);
});

// 初始化Vue实例
new Vue({
  el: "#app",
  router,
  axios,
  store,
  components: {
    App
  },
  template: "<App/>"
});



// WEBPACK FOOTER //
// ./src/main.js